/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
(function(algolia) {
'use strict';
setTimeout(() => {
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var configure = algolia.externals.widgets.configure;
  var queryRuleCustomData = algolia.externals.widgets.queryRuleCustomData;
  var connectCurrentRefinements =
    algolia.externals.connectors.connectCurrentRefinements;
  var aa = algolia.externals.aa;

  var collectionPageEnabled =
    algolia.is_collection_results_page &&
    algolia.config.instant_search_enabled_on_collection;

  if (!algolia.full_results && !algolia.is_collection_results_page) {
    /**
     * If we aren't on the search page and neither on a collection page,
     * then there's no need to proceed
     */
    return;
  } else if (algolia.full_results) {
    /**
     * If we are on the search page and instant search isn't enabled,
     * then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled) {
      return;
    }
  } else if (algolia.is_collection_results_page) {
    /**
     * If we are on a collection page and instant search on collection isn't
     * enabled, then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled_on_collection) {
      return;
    }
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];

  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  var collectionHandle = null;

  if (collectionPageEnabled) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    collectionHandle =
      Boolean(matches) && matches.length === 2 ? matches[1] : null;

    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = algolia.current_collection_id
        ? 'collection_ids:"' + algolia.current_collection_id + '"'
        : null;
    } else {
      collectionFacetFilter = 'collections:"' + collectionHandle + '"';
    }

    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);

    collectionRulesContextValue = algolia.config.collection_id_query_rules
      ? algolia.current_collection_id
      : collectionHandle;
  }

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var results_selector = collectionPageEnabled
    ? algolia.config.collection_css_selector
    : algolia.config.results_selector;

  var activeSortOrders =
    collectionPageEnabled && algolia.collectionSortOrders
      ? algolia.collectionSortOrders
      : algolia.sortOrders;

  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /**
   * List of URL params which are "allowed" by InstantSearch.
   * These parameters won't be overwritten when the search state is written
   * to the URL.
   */
  var ALLOWED_FOREIGN_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function(routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function(acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden:
        collectionPageEnabled && algolia.collectionHiddenFacets
          ? algolia.collectionHiddenFacets
          : algolia.hiddenFacets,
      shown:
        collectionPageEnabled && algolia.collectionShownFacets
          ? algolia.collectionShownFacets
          : algolia.shownFacets,
      list:
        collectionPageEnabled && algolia.collectionFacets
          ? algolia.collectionFacets
          : algolia.facets,
      widgets:
        collectionPageEnabled && algolia.collectionFacetsWidgets
          ? algolia.collectionFacetsWidgets
          : algolia.facetsWidgets,
    },
    hitsPerPage:
      collectionPageEnabled &&
      algolia.config.collections_full_results_hits_per_page
        ? algolia.config.collections_full_results_hits_per_page
        : algolia.config.products_full_results_hits_per_page,
    poweredBy: algolia.config.powered_by,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      indexName: algolia.config.index_prefix + 'products',
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
      },
      searchFunction: function(searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();

        searchFunctionHelper.setQueryParameter(
          'highlightPreTag',
          '<span class="ais-highlight">'
        );
        searchFunctionHelper.setQueryParameter('highlightPostTag', '</span>');
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter(
            'filters',
            searchFilters.join(' AND ')
          );
        }

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        if (collectionPageEnabled) {
          // Collection page merchandising:
          // If we are on a collection page, `collectionRulesContextValue` is defined
          if (collectionRulesContextValue) {
            searchFunctionHelper.setQueryParameter('ruleContexts', [
              collectionRulesContextValue.toString(),
            ]);
          } else {
            searchFunctionHelper.setQueryParameter('ruleContexts', []);
          }
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders,
    storeName: algolia.storeName,
    templates: {
      currentItem: algolia.getTemplate(
        'instant_search_current_refined_values_item'
      ),
      // empty: algolia.getTemplate('instant_search_no_result'),
      empty(results) {
        return `No results <q>${results.query}</q>`;
      },
      page: algolia.compileTemplate('instant_search'),
      product: algolia.getTemplate('instant_search_product'),
      stats: algolia.getTemplate('instant_search_stats'),
      style: algolia.compileTemplate('instant_search.css'),
    },
  };

  algolia.instantsearch = instant;

  if (instant.poweredBy) {
    // eslint-disable-next-line no-console
    console.log('Algolia: Instant-Search');
  }

  function readjust() {
    var width = instant.$results.offsetWidth;

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }

  // Bind helpers
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  Object.keys(helpers).forEach(function(name) {
    var helper = helpers[name];
    instant.search.templatesConfig.helpers[name] = helper;
  });
  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

  algolia.appendStyle(
    algolia.render(instant.templates.style, {
      distinct: instant.distinct,
      colors: instant.colors,
    })
  );

  if (collectionPageEnabled) {
    if (
      document.querySelectorAll(algolia.config.collection_css_selector)
        .length === 0
    ) {
      throw new Error(
        'Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector'
      );
    }
  } else if (
    document.querySelectorAll(algolia.config.results_selector).length === 0
  ) {
    throw new Error(
      'Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  }

  instant.$results = document.querySelector(instant.selector);

  instant.$results.innerHTML = algolia.render(instant.templates.page, {
    facets: instant.facets.list,
    storeName: instant.storeName,
    translations: algolia.translations,
    multipleSortOrders: activeSortOrders.length > 1,
  });

  readjust();

  window.addEventListener('resize', function() {
    readjust();
  });

  // Mobile facets display
  instant.search.addWidgets([
    {
      init: function() {
        var $button = document.querySelector('.ais-facets-button');
        var facetsCloseButtons = document.querySelectorAll('[data-filters-close]');
        var $facets = document.querySelector('.ais-facets');
        var facetsBody = document.querySelector('[data-filters-body]');
        $button.addEventListener('click', function() {

          if ($facets.classList.contains('ais-facets__shown')) {
            $facets.classList.remove('ais-facets__shown', 'is-visible');
            bodyScrollLock.enableBodyScroll(facetsBody);
            removeTrapFocus($button)
          } else {
            $facets.classList.add('ais-facets__shown', 'is-visible');
            bodyScrollLock.disableBodyScroll(facetsBody);
            trapFocus($facets, facetsCloseButtons[0])
          }
        });
        facetsCloseButtons.forEach(function (button) {
          button.addEventListener('click', function (event) {
            $facets.classList.remove('ais-facets__shown', 'is-visible');
            bodyScrollLock.enableBodyScroll(facetsBody);
            removeTrapFocus($button)
          });
        });
      },
    },
  ]);

  instant.search.addWidgets([
    configure({
      hitsPerPage: 14,
      clickAnalytics: true,
      facetingAfterDistinct: Boolean(algolia.config.show_products),
    }),
  ]);

  // Search input
  instant.search.addWidgets([
    searchBox({
      container: '.ais-search-box-container',
      placeholder: algolia.translations.searchForProduct,
      showReset: false,
      showSubmit: false,
    }),
  ]);

  // Stats
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text: instant.templates.stats,
      },
    }),
  ]);

  // Sort orders
  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-container',
        items: instant.sortOrders,
      }),
    ]);
  }

  // Change display
  instant.search.addWidgets([
    {
      init: function() {
        document
          .querySelector('.ais-change-display .ais-change-display-block')
          .addEventListener('click', function() {
            document
              .querySelector(
                '.ais-change-display-block:not(.ais-change-display-selected)'
              )
              .classList.add('ais-change-display-selected');
            document
              .querySelector(
                '.ais-change-display-list.ais-change-display-selected'
              )
              .classList.remove('ais-change-display-selected');
            document
              .querySelector('.ais-results-as-list')
              .classList.replace('ais-results-as-list', 'ais-results-as-block');
          });
        document
          .querySelector('.ais-change-display .ais-change-display-list')
          .addEventListener('click', function() {
            document
              .querySelector(
                '.ais-change-display-list:not(.ais-change-display-selected)'
              )
              .classList.add('ais-change-display-selected');
            document
              .querySelector(
                '.ais-change-display-block.ais-change-display-selected'
              )
              .classList.remove('ais-change-display-selected');
            document
              .querySelector('.ais-results-as-block')
              .classList.replace('ais-results-as-block', 'ais-results-as-list');
          });
      },
    },
  ]);

  // Hidden facets
  var list = instant.facets.hidden.map(function(facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function() {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function() {},
    },
  ]);

  // Create the render function
  var createDataAttribtues = function(refinement) {
    return Object.keys(refinement)
      .map(function(key) {
        return 'data-' + key + '="' + refinement[key] + '"';
      })
      .join(' ');
  };

  var renderListItem = function(item) {
    var facet = instant.facets.list.find(function(f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function(refinement) {
        return (
          '<li class="ais-current-refined-values--item">' +
          '  <button ' + 
          createDataAttribtues(refinement) +
          '    class="ais-current-refined-values--link" aria-describedby="Remove ' + refinement.label + ' filter ">' +
            refinement.label +
            '<svg  aria-hidden="true" focusable="false" role="presentation" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M8.48627 9.32917L2.82849 3.67098" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"/>' +
              '<path d="M2.88539 9.38504L8.42932 3.61524" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '  </button>' +
          '</li>'
        );
      })
      .join('');
  };

  var showHideFeaturedItems = function () {
    if(document.querySelector('.ais-ClearRefinements-button--disabled')){
      document.body.classList.remove('hide-featured-collection-items')
    } else {
      document.body.classList.add('hide-featured-collection-items')
    }
  }

  var renderCurrentRefinements = function(renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;

    showHideFeaturedItems();
    widgetParams.container.innerHTML =
      '<div class="ais-root ais-current-refined-values ais-facet">' +
      '  <ul class="ais-current-refined-values--list">' +
      items.map(renderListItem).join('') +
      '  </ul>' +
      '</div>';

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll(
          '.ais-current-refined-values--link'
        )
      )
      .forEach(function(element) {
        element.addEventListener('click', function(event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function(
            acc,
            key
          ) {
            var itemData = {};
            itemData[key] = event.currentTarget.dataset[key];
            return algolia.assign({}, acc, itemData);
          },
          {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  );

  var hasRefinements = function(helper, facetsList) {
    return facetsList.some(function(f) {
      var isConjunctiveFacetRefined =
        helper.state.isConjunctiveFacet(f.name) &&
        helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined =
        helper.state.isDisjunctiveFacet(f.name) &&
        helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined =
        helper.state.isHierarchicalFacet(f.name) &&
        helper.state.isHierarchicalFacetRefined(f.name);

      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function(
        operator
      ) {
        return numericRefinements[operator].length > 0;
      });

      return (
        isNumericFacetRefined ||
        isConjunctiveFacetRefined ||
        isDisjunctiveFacetRefined ||
        isHierarchicalFacetRefined
      );
    });
  };

  // Create the sort render function
  const renderSortBy = (renderOptions, isFirstRender) => {
    const {
      options,
      currentRefinement,
      canRefine,
      refine,
      widgetParams,
    } = renderOptions;

    if (isFirstRender) {
      const select = document.createElement('div');
      select.classList.add('dropdown');

      const dropdownToggle = select.innerHTML = `
        <label for="sortByButton" class="collection__sort__label button-link button-link--medium" aria-labelledby="sort-by">Sorted by</label>
        <button id="sortByButton" class="dropdown-toggle button--clear select__select" type="button" aria-haspopup="true">
          <span class="label-mobile">Sort</span>
          <span class="label-desktop">
            ${options
              .map( 
                option =>  {
                  if (option.value === currentRefinement) {
                    return option.label
                  }
                }
              ).filter(_ => _)
            }
          </span>
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" width="6" viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m1.064.756 2 2 2-2" stroke="url(#a-caret-43212)"/><defs><linearGradient id="a-caret-43212" x1="3.295" y1=".558" x2="4.438" y2="2.563" gradientUnits="userSpaceOnUse"><stop stop-color="#E3AD42"/><stop offset="1" stop-color="#96722A" stop-opacity=".95"/></linearGradient></defs></svg>
        </button>
        <ul class="dropdown-menu" role="listbox" aria-expanded="false" aria-labelledby="sortByButton">
        ${options
          .map(
            option => `
              <li
                role="option"
                tabindex="0"
                data-value="${option.value}"
                class="${option.value === currentRefinement ? 'selected' : ''}"
              >
                ${option.label}
              </li>
            `
          )
          .join('')}
        </ul>
      `
      widgetParams.container.appendChild(select);
    }

    const selectList = widgetParams.container.querySelector('.dropdown ul');
    const select = widgetParams.container.querySelector('.dropdown');
    const selectLabel = widgetParams.container.querySelector('.dropdown .label-desktop');

    selectLabel.innerHTML = `
      ${options
        .map(
          option =>  {
            if (option.value === currentRefinement) {
              return option.label
            }
          }
        ).filter(_ => _)
      }
    `;

    selectList.innerHTML = `
    ${options
      .map(
        option => `
          <li
            role="option"
            tabindex="0"
            data-value="${option.value}"
            class="${option.value === currentRefinement ? 'selected' : ''}"
          >
            ${option.label}
          </li>
        `
      )
      .join('')}
  `;

    algolia.helpers.customSelect(select, refine, isFirstRender);
  };

  // Create the custom widget
  const connectSortBy =  window.instantsearch.connectors.connectSortBy
  const customSortBy = connectSortBy(renderSortBy);

  // Instantiate the custom widget
  instant.search.addWidgets([
    customSortBy({
      container: document.getElementById('sort-by'),
      items: instant.sortOrders
    })
  ]);

  /**
   * Decides whether the given `facetName` has any facet values available in
   * the current result set by checking the available `facets`,
   * `disjunctiveFacets` and `hierarchicalFacets`.
   */
  var hasFacetValues = function(resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function(facet) {
      return facet.name === facetName;
    });
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );

    return (
      isFacetValueAvailable ||
      isDisjunctiveFacetValueAvailable ||
      isHierarchicalFacetValueAvailable
    );
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var clearRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(clearRefinements);

  instant.search.addWidgets([
    clearRefinementsWithPanel({
      container: document.querySelector('.ais-clear-refinements-container'),
      templates: {
        resetLabel: algolia.translations.clearAll,
      },
    }),
    customCurrentRefinementsWithPanel({
      container: document.querySelector(
        '.ais-current-refined-values-container'
      ),
    }),
  ]);

  /**
   * Setup the facets for search.
   * We are using a `panel` with a custom `hidden` function which will allow
   * us to hide the parent container of the facet if there are no facet values
   * available for that particular facet.
   */
  instant.facets.widgets.forEach(function(widget) {
    var facetWithPanel = panel({
      hidden: function(options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute);
        var displayStyle = hide ? 'none' : '';

        /**
         * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
         * can work as expected. "." is supposed to be present for named tags
         * and metafield based facet names and "%" is present when the facet name has a space
         * in it because of the encoding.
         */
        var parentContainerClassName = '.ais-facet-' + encodeURIComponent(
          widget.params.attribute
        ).replace(/\./g, '\\.').replace(/\%/g, '\\%');
        var parentContainer = document.querySelector(parentContainerClassName);

        if (parentContainer) {
          parentContainer.style.display = displayStyle;
        }

        return hide;
      },
    })(widget.widget);

    instant.search.addWidgets([facetWithPanel(widget.params)]);
  });

  var renderInfiniteHits = function(renderOptions, isFirstRender) {
    let currentHits;

    const getWidth = () => Math.ceil((renderOptions.results.page + 1) / renderOptions.results.nbPages * 100);

    if (currentHits !== renderOptions.hits.length) {
      currentHits = renderOptions.hits.length;
      const progressBar = document.getElementById('pBar');
      if (progressBar) {
        progressBar.innerHTML =`<div class="load-progress-bar__inner" style="width:${ getWidth() }%"><div>`
      }
    }

    if (isFirstRender) {
      // var emptyContainer = document.createElement('div');
      var ol = document.createElement('ol');
      ol.className = 'ais-InfiniteHits-list';
      // emptyContainer.className = 'ais-InfiniteHits-empty';

      const nextButton = document.createElement('button');
      nextButton.className = 'button ais-InfiniteHits-loadMore';
      nextButton.textContent = `Load more`;

      const divEl = document.createElement('div');
      divEl.id = 'pBar'
      divEl.className = 'load-progress-bar';

      nextButton.append(divEl)

      nextButton.addEventListener('click', () => {
         renderOptions.showMore()
      });

      // renderOptions.widgetParams.container.appendChild(emptyContainer);
      renderOptions.widgetParams.container.appendChild(ol);
      renderOptions.widgetParams.container.appendChild(nextButton);
      renderOptions.widgetParams.container.appendChild(divEl);

      return;
    }

    renderOptions.widgetParams.container.querySelector('.ais-InfiniteHits-loadMore').disabled = renderOptions.isLastPage;
    renderOptions.widgetParams.container.querySelector('ol').classList.toggle('hidden', renderOptions.hits.length === 0);
    document.querySelector('.ais-InfiniteHits-empty').classList.toggle('hidden', renderOptions.hits.length !== 0);
    document.querySelector('.template-search__wrapper-top');
    // if(document.querySelector('.template-search__wrapper-top')) {
    //   document.querySelector('.template-search__wrapper-top').classList.toggle('hidden', renderOptions.hits.length === 0)
    // }

    if (renderOptions.hits.length === 0) {
      document.querySelector('.ais-InfiniteHits-empty').innerHTML =
        algolia.render(
          algolia.compileTemplate('instant_search_no_result'),
          {}
        );

      return;
    }

    renderOptions.widgetParams.container.querySelector('ol').innerHTML =
      renderOptions.hits.map(
        function(item) {
          // Add in-grid blocks
          var blocksHtml = '';
          if (Shopify.collection.blocks) {
            blocksHtml = Shopify.collection.blocks.map(function(block) {
              if (item.productPosition !== block.order) {
                return '';
              }

              return (
                '<li class="ais-InfiniteHits-item featured-content">' +
                  '<div class="featured-content__wrapper">' +
                    '<picture class="featured-content__image">' +
                      '<img width="auto" height="auto" loading="lazy"' +
                        'src="' + block.image + '"' +
                        'alt="' + block.title + '"' +
                      '>' +
                    '</picture>' +
                    '<div class="featured-content__content">' +
                      '<p class="featured-content__title h3">' +
                        block.title +
                      '</p>' +
                      (
                        block.text
                          ?
                          '<p class="featured-content__text">' +
                            block.text +
                          '</p>'
                          : ''
                      ) +
                      (
                        (block.cta_label && block.cta_url)
                          ?
                          '<a ' +
                            'href="' + block.cta_url + '" ' +
                            'class="featured-content__btn btn btn-primary"' +
                          '>' +
                            block.cta_label +
                          '</a>'
                          : ''
                      ) +
                    '</div>' +
                  '</div>' +
                '</li>'
              );
            }).join('');
          }

          return (
            blocksHtml +
            '<li class="ais-InfiniteHits-item">' +
              algolia.render(
                algolia.compileTemplate('instant_search_product'),
                item
              ) +
            '</li>'
          );
        }
      )
      .join('');

    algolia.helpers.metaImage();
  }

  var customInfiniteHits = window.instantsearch.connectors.connectInfiniteHits(
    renderInfiniteHits
  );

  instant.search.addWidgets([
    customInfiniteHits({
      container: document.querySelector('.ais-InfiniteHits'),
      transformItems: function(products) {
        var arrayProducts = [];
        return products.map(function(product) {
          let review_id = product.id;
          if(product.meta.bzv?.review_product.length > 0) {
            review_id = product.meta.bzv.review_product;
            review_id = review_id.substring(review_id.lastIndexOf('/') + 1);
          }
          const metaShowSecondImage = product.meta?.custom?.show_hover_image
          const showSecondImage = show_secondary_image || metaShowSecondImage
          return algolia.assign({}, product, {
            _distinct: instant.distinct,
            can_order:
              product.inventory_management !== 'shopify' ||
              product.inventory_policy === 'continue' ||
              product.inventory_quantity > 0,
            translations: algolia.translations,
            queryID: product.__queryID,
            productPosition: product.__position,
            index: instant.search.mainIndex.getIndexName(),
            productId: product.id,
            productUrl: product.handle,
            productReviewId: review_id,
            bundle: product.tags.includes('bundle'),
            showSecondImage: showSecondImage
          });
        });
      },
    })
  ]);

  // No result actions
  instant.search.addWidgets([
    {
      init: function(opts) {
        var container = document.querySelector('.ais-InfiniteHits');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function(facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
    },
  ]);

  // custom
  const searchTriggerAgain = document.querySelector('.js-search-again');
  const searchFocus = function () {
    const searchBar = document.querySelector('.js-header-searchbar');
    searchTriggerAgain.classList.add('is-active');
    searchBar.classList.add('is-visible');
    if (searchTriggerAgain.classList.contains('is-active')) {
      document.body.classList.add('overflow-hidden');
      searchTriggerAgain.classList.remove('is-active');
      document.querySelector('.header__search__input').focus({focusVisible: true});
    }else {
      document.body.classList.remove('overflow-hidden');
    }
  }

  if (searchTriggerAgain) {
    searchTriggerAgain.addEventListener('click', searchFocus);
    searchTriggerAgain.addEventListener('keyup', (e) => {
      if (e.keyCode === 13) {
        searchFocus();
      }
    });
  }

  instant.search.addWidgets([
    queryRuleCustomData({
      container: '#queryRuleCustomData',
      templates: {
        default: '',
      },
      transformItems(items) {
        const match = items.find(data => Boolean(data.redirect));
        if (match && match.redirect) {
          window.location.href = match.redirect;
        }
        return [];
      },
    })
  ])
  

  // Main
  instant.search.start();

  algolia.contentHide.parentNode.removeChild(algolia.contentHide);
}, 300);
})(window.algoliaShopify);
